module.exports = __webpack_public_path__ + "media/images/referrals/in-recovery-e929103bc59bd5ef891d30740440081a.png";